// eslint-disable-next-line import/prefer-default-export
export const pageViewer = url => {
  window.gtag('config', process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS, {
    page_path: url
  });
};
